export enum IconType {
  Icon = 'icon',
  Emoji = 'emoji',
  Image = 'image',
}
